<template>
  <section>
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
      tag="div"
    >
      <form @submit.prevent="submit">
        <div class="support-form">
          <input-form
            v-model="subject"
            :title="$t('question.subject')"
            name="subject"
            :placeholder="$t('question.subjectPlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            rules="required"
            maxlength="50"
          />

          <input-form
            id="name"
            ref="name"
            v-model="name"
            :title="$t('question.name')"
            name="name"
            :placeholder="$t('question.namePlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            rules="required"
            maxlength="50"
          />

          <input-form
            id="offer"
            ref="offer"
            v-model="offer"
            :title="$t('question.organization')"
            name="offer"
            :placeholder="$t('question.organizationPlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            rules="required"
            maxlength="50"
          />

          <input-form
            id="mail"
            ref="mail"
            v-model="mail"
            :title="$t('question.email')"
            name="mail"
            :placeholder="$t('question.emailPlaceholder')"
            type="email"
            autocomplete="off"
            required="required"
            rules="required"
            maxlength="50"
          />

          <input-form
            id="textarea"
            ref="textarea"
            v-model="textarea"
            :title="$t('question.detail')"
            name="textarea"
            :placeholder="$t('question.detailPlaceholder')"
            type="textarea"
            autocomplete="off"
            required="required"
            maxlength="20000"
          />

          <input-form
            id="file"
            v-model="file"
            :title="$t('question.attachFile')"
            :placeholder="$t('question.attachFilePlaceholder')"
            type="file"
            :is-upload="attachFileUrl !== null"
            :loading="fileLoading"
            :error-message="fileError"
            @input="attachUpload"
            @change:delete="onDeleteFile"
          >
            <small>{{ $t('question.attachFileNote') }}</small>
          </input-form>
        </div>

        <div class="support-agree">
          <div class="agree-check-all">
            <check-box
              id="all"
              v-model="agreeAll"
              :text="$t('question.agreeAll')"
              name="agree-all"
              @input="onChangeAgreeAll($event)"
            />
          </div>
          <div class="agree-wrap">
            <div class="agree-title">{{ $t('question.privateTitle') }}</div>
            <div class="agree-content">
              <div class="agree-check">
                <check-box
                  id="private"
                  ref="private"
                  v-model="agreePrivate"
                  :text="$t('question.private')"
                  name="agree-private"
                  required
                />
              </div>
              <html-view class="agree-term" :value="$t('question.privateValue')" />
            </div>
          </div>
          <div class="agree-wrap">
            <div class="agree-title">유의사항 안내</div>
            <div class="agree-content">
              <div class="agree-check">
                <check-box
                  id="precautions"
                  ref="precautions"
                  v-model="agreePrecautions"
                  :text="$t('question.precautions')"
                  name="precautions"
                  required
                />
              </div>
              <html-view class="agree-term" :value="$t('question.precautionValue')" />
            </div>
          </div>
        </div>

        <div class="support-btn">
          <button type="submit" class="btn btn-fill btn-wide" :disabled="invalid">{{ $t('question.submit') }}</button>
        </div>
      </form>
    </validation-observer>
  </section>
</template>
<script>
import supportForm from '@/mixins/supportForm'

export default {
  mixins: [supportForm],
  data () {
    return {
      agreePrecautions: false,
    }
  },
  watch: {
    agreePrivate (v) {
      if (!v) this.agreeAll = false
      if (v && this.agreePrecautions) {
        this.agreeAll = true
      }
    },
    agreePrecautions (v) {
      if (!v) this.agreeAll = false
      if (v && this.agreePrivate) {
        this.agreeAll = true
      }
    }
  },
  mounted () {
    this.questionType = 'OFFER'
  },
  methods: {
    submit () {
      this.saveQuestion({
        company: this.offer,
        content: this.textarea,
        email: this.mail,
        name: this.name,
        title: this.subject,
        type: ['OFFER']
      })
    },
    onChangeAgreeAll (v) {
      if (v) {
        this.agreePrivate = true
        this.agreePrecautions = true
      } else {
        this.agreePrivate = false
        this.agreePrecautions = false
      }
    }
  }
}
</script>
